module.exports = __webpack_public_path__ + "static/9-8d0d546c592d388b2569e41e4aa3d908.jpg";